import type { SVGProps } from "react";
export interface BrushIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function BrushIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: BrushIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M5.414 7.52a1.126 1.126 0 0 1 1.506-.078l.085.078 9.475 9.475.078.085a1.126 1.126 0 0 1-1.584 1.583l-.085-.078-9.475-9.474-.077-.085a1.126 1.126 0 0 1 .077-1.506m1.322 6.586.797.795-2.454 2.453a1.125 1.125 0 1 1-1.59-1.591l2.451-2.454zm-.796-.797a1.127 1.127 0 0 1 1.593 1.592L5.94 13.31Z"
      />
      <path
        fill={color}
        d="M15.477 2.45a4.314 4.314 0 0 1 6.383-.309l.168.18a4.314 4.314 0 0 1-.672 6.352l-3.148 2.302a.98.98 0 0 0-.219 1.36l.386.54.158.245a3.23 3.23 0 0 1-.504 3.916l-5.145 5.145a3.23 3.23 0 0 1-4.568 0l-6.497-6.497a3.23 3.23 0 0 1 0-4.567L6.964 5.97l.216-.198a3.23 3.23 0 0 1 3.947-.147l.537.386.172.096a.98.98 0 0 0 1.19-.316l2.302-3.147.15-.194Zm4.792 1.282a2.064 2.064 0 0 0-2.977.06l-.15.18-2.3 3.148a3.23 3.23 0 0 1-4.209.898l-.275-.177-.54-.384a.98.98 0 0 0-1.262.104L3.41 12.707a.98.98 0 0 0 0 1.386l6.496 6.497a.98.98 0 0 0 1.388 0l5.144-5.145a.98.98 0 0 0 .195-1.112l-.09-.152-.385-.538a3.23 3.23 0 0 1 .723-4.485l3.146-2.301a2.064 2.064 0 0 0 .397-2.95z"
      />
    </svg>
  );
}
